import { createSlice } from '@reduxjs/toolkit';
import { displayInitialState } from './display.defaults';

export const nearbyArtistsDisplaySlice = createSlice({
  name: 'display',
  initialState: displayInitialState,
  reducers: {
    OPEN_FILTERS_NearbyArtists: (state) => {
      state.isFiltersDialogOpen = true;
    },
    CLOSE_FILTERS_NearbyArtists: (state) => {
      state.isFiltersDialogOpen = false;
    },
  },
});
